import { render, staticRenderFns } from "./UpgradeHost.vue?vue&type=template&id=026ac6d3&"
import script from "./UpgradeHost.vue?vue&type=script&lang=js&"
export * from "./UpgradeHost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports